import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXTAREA,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useHowWasCollected(): StaticSharedField {
  const { t } = useTranslation();

  return {
    type: FIELD_TYPE_TXTAREA,
    propName: 'data_source',
    element: 'data_source',
    labelI18nKey: 'business:QuestionPage.forms.otherFuels.para5',
    descriptionI18nKey: 'business:QuestionPage.forms.otherFuels.para6',
    placeholderI18nKey: 'business:QuestionPage.forms.otherFuels.dataPlaceholder',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNODATASOURCE',
        errStr: t('business:Errors.dataSource.provide'),
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: 'ERRDATASOURCETOOSHORT',
        errStr: t('business:Errors.dataSource.provide'),
        value: 5,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: 'ERRDATASOURCETOOLONG',
        errStr: t('business:Errors.dataSource.provide'),
        value: 3000,
      },
    ],
  };
}
